const { gql } = require("graphql-tag");
const jsonata = require("jsonata");

var _parent = {};
let log = false;

var invoices = {
  init: p => (_parent = p),

  getInvoiceById: async function (invoiceId) {
    const res = await _parent.gql.query(
      gql`
        query getInvoiceDetailsByInvoiceId($invoiceId: bigint!) {
          invoices: arinvoices(where: {id: {_eq: $invoiceId}}, order_by: {end_datetime: desc}) {
          ...Invoices
          }
        }
        ${_parent.fragments.invoices()}
      `,
      { invoiceId }
    );
    return res;
  },

  getAllInvoices: async function (variables) {
    const { limit, offset, customerId, from } = variables;

    const res = await _parent.gql.query(
      gql`
        query getAllInvoices($limit: Int!, $offset: Int!, $from: timestamptz, $customerId: bigint) {
          invoices: arinvoices(
            limit: $limit, 
            offset: $offset, 
            where:{ 
              ${from ? 'start_datetime: {_gte: $from }' : ''}, 
              ${customerId ? 'customer_id: {_eq: $customerId }' : ''} 
            }, 
            order_by: {end_datetime: desc}) {
           ...Invoices
          }
        }
        ${_parent.fragments.invoices()}
      `,
      { limit, offset, from, customerId }
    );
    return res;
  },

  buildGetResponseObj: async function (invoice) {
    const updatedResponse = jsonata(`data.{
      "id": id,
      "status": status,
      "due_amount": due_amount.aggregate.sum.due_amount,
      "paid_amount": paid_amount.aggregate.sum.paid_amount,
      "balance_remaining": $sum((due_amount.aggregate.sum.due_amount ? due_amount.aggregate.sum.due_amount : 0) - (paid_amount.aggregate.sum.paid_amount ? paid_amount.aggregate.sum.paid_amount : 0) - (discount_amount.aggregate.sum.discount_amount ? discount_amount.aggregate.sum.discount_amount : 0)),
      "payments": payments,
      "start_datetime": start_datetime,
      "end_datetime": end_datetime,
      "customer": customer{
          "id": id,
          "name": $trim(name)
      },
      "charges": charges.{
          "id": id,
          "move_id": move_id,
          "type": type,
          "status": status,
          "disputed": disputed,
          "dispute_reason": dispute_reason,
          "discount_amount": discount_amount,
          "discount_reason": discount_reason,
          "due_amount": due_amount,
          "paid_amount": paid_amount,
          "balance_remaining": ((due_amount ? due_amount : 0) - (paid_amount ? paid_amount : 0) - (discount_amount ? discount_amount : 0)),
          "details": details.{
              "name": $lowercase(name),
              "notes": notes,
              "amount": amount,
              "mileage_band": mileage_band
          }
        }
      }`
    );

    const result = await updatedResponse.evaluate(invoice);
    return result;
  },
};

module.exports = invoices;